import { useContext } from "react";
import { ThemeContext, type ThemeContextValue } from "./ThemeContext";

/**
 * Reads the current theme from a `<ThemeProvider>` in the tree.
 *
 * Has a no-op fallback when no provider is present (e.g. Storybook stories
 * rendered outside the app shell). The fallback inspects the `dark` class
 * on `<html>` so stories that have manually toggled dark mode still report
 * the right resolved theme.
 */
export function useThemeContext(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    if (typeof document === "undefined") {
      return {
        theme: "light",
        setTheme: () => {},
        resolvedTheme: "light",
      };
    }
    const isDark = document.documentElement.classList.contains("dark");
    return {
      theme: isDark ? "dark" : "light",
      setTheme: () => {},
      resolvedTheme: isDark ? "dark" : "light",
    };
  }
  return ctx;
}
